module.exports = __webpack_public_path__ + "static/media/game_icon_wd.70d3ad39.png";